<template>
  <div id="idc">
    <router-view :currentPage="this.$router.history.current.meta.layout"
                 :currentRouterName="this.$router.history.current.name"
                 @setLocale="setLocale">
    </router-view>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'idc',
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters([
        'userInfo'
      ])
    },
    watch: {
      'userInfo': function (value) {
        var scriptChatbox
        if (value) {
          scriptChatbox = document.createElement('script')
          var chatbox = document.createTextNode(`
          var Tawk_API=Tawk_API||{};
              Tawk_API.visitor = {
                  name  : '${value.fullname}',
                  email : '${value.email}'
              };
              Tawk_LoadStart=new Date();
              (function(){var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];s1.async=true;s1.src='https://embed.tawk.to/5423d8fad788df513200062b/default';s1.charset='UTF-8';s1.setAttribute('crossorigin','*');s0.parentNode.insertBefore(s1,s0);})();
          `)
          scriptChatbox.appendChild(chatbox)
          document.body.appendChild(scriptChatbox)
        } else {
          const scripts = document.getElementsByTagName('script')
          let i = scripts.length
          while (i--) {
            scripts[i].parentNode.removeChild(scripts[i])
          }
        }
      }
    },
    methods: {
      setLocale (locale) {
        this.$i18n.locale = locale
      }
    },
    mounted () {
    }
  }
</script>
<style lang="scss" src="./assets/scss/main.scss"></style>



// WEBPACK FOOTER //
// src/App.vue